<template>
  <div id="app" >
    <router-view v-if="isRresh"/>
  </div>
</template>

<script>
export default{
  data(){
    return{
      isRresh:true
    }
  },
  provide(){
    return {
      refresh:this.refresh
    }
  },
  methods:{
    refresh() {
      this.isRresh = false
      this.$nextTick(() => {
        this.isRresh = true
      })
    }
  }
}

</script>

<style scoped="scoped">

.nr{
	margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue